import Button from '@orn/shared-web/components/Button/Button';
import { PlusIcon } from '@orn/shared-web/icons';
import { cx } from '@orn/shared-web/utils/cx';
import * as React from 'react';

export interface IDashedAddButtonProps {
  onClick: () => void;
  isDisabled?: boolean;
  /** Underlying Button size. @default "md" */
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  /** Button label, e.g. "Add location". */
  children: React.ReactNode;
}

/**
 * Centered "add an item" affordance shared by the settings forms: a secondary
 * Button with its ring swapped for a dashed 12px-radius border and a leading
 * plus icon. Used below item lists (frequent locations, vehicles).
 */
const DashedAddButton = ({ onClick, isDisabled, size = 'md', className, children }: IDashedAddButtonProps) => (
  <Button
    color="secondary"
    size={size}
    iconLeading={PlusIcon}
    onClick={onClick}
    isDisabled={isDisabled}
    className={cx('border-primary self-center rounded-xl border border-dashed ring-0', className)}
  >
    {children}
  </Button>
);

DashedAddButton.displayName = 'DashedAddButton';

export default DashedAddButton;
